<template>
  <div class="talentq-report">
    <div v-if="talentq.is_passed !== null" class="item">
      {{ $tr('responses.tabs.test.talentq.is-passed') }}:
      {{
        talentq.is_passed
          ? $tr('responses.tabs.test.talentq.is-passed-completed')
          : $tr('responses.tabs.test.talentq.is-passed-failed')
      }}
    </div>

    <div v-for="(item, index) in prepared_data" :key="index" class="response-item">
      <div class="sub-title">{{ item.title }}:</div>
      <div class="item">{{ `${$tr('responses.tabs.test.talentq.status')} ${item.status}` }}</div>
      <template v-if="item.have_result">
        <div v-for="(result, indexResult) in item.results" :key="indexResult" class="item">
          {{ `${result.scale}: ${result.value}` }}
        </div>
      </template>
      <div v-else class="item">{{ $tr('responses.tabs.test.talentq.noResult') }}</div>
    </div>

    <div v-if="talentq.pdf_report" class="item">
      {{ $tr('responses.tabs.test.talentq.pdf-report') }}:
      <a target="_blank" rel="noopener" :href="talentq.pdf_report">
        {{ $tr('onlineInterview.room.goto') }}
      </a>
    </div>

    <vbutton
      v-else
      label="responses.tabs.test.talentq.load-pdf-report"
      @click="$emit('load-pdf-report')"
    />

    <vue-it-bigger
      ref="lightbox"
      :media="screenshots"
      :show-light-box="false"
      :interface-hide-time="300000"
      show-caption
    />
    <screenshots v-if="screenshots.length > 0" :media="screenshots" @open-gallery="openGallery" />
  </div>
</template>

<script>
  import VueItBigger from 'vue-it-bigger';
  import('vue-it-bigger/dist/vue-it-bigger.min.css');
  import Screenshots from './Screenshots';
  import Moment from 'moment';
  import Axios from 'axios';
  import { TALENTQ_ASSESSMENT_STATUSES } from '@/process/danone/components/constants';

  export default {
    name: 'TabTalentq',

    components: {
      VueItBigger,
      Screenshots
    },

    props: {
      talentq: {
        type: Object,
        default: () => {}
      }
    },

    data() {
      return {
        screenshots: []
      };
    },

    computed: {
      prepared_data() {
        return this.talentq.report.map(item => {
          const have_result =
            item.status.id === TALENTQ_ASSESSMENT_STATUSES.COMPLETE && item.score[0];
          return {
            title: item.code.title,
            status: item.status.title,
            have_result,
            results: item.score
          };
        });
      }
    },

    created() {
      this.fetchCameraScreens();
    },

    methods: {
      fetchCameraScreens() {
        Axios.get(`/1.0/spec-private/custom-process/image/${this.$route.params.id}`).then(
          response => {
            this.screenshots = response.data.data
              .sort((a, b) => {
                return a.created_at > b.created_at ? 1 : -1;
              })
              .map(x => {
                return {
                  type: 'image',
                  thumb: x.preview,
                  src: x.url,
                  caption: Moment(x.created_at).format('lll')
                };
              });
          }
        );
      },

      openGallery(index) {
        this.$refs.lightbox.showImage(index);
      }
    }
  };
</script>

<style scoped lang="scss">
  .talentq-report {
    padding: 5px 0;
    border-bottom: 1px solid #ddd;

    .title {
      text-align: center;
      font-size: 18px;
      font-weight: bold;
      margin: 15px 0;
    }

    .response-item {
      margin: 15px 0;
      .sub-title {
        font-size: 16px;
        font-weight: bold;
        margin: 10px 0;
      }
    }

    .item {
      font-size: 15px;
      margin: 5px 0;
    }
  }

  ::v-deep .vib-container {
    z-index: 10000 !important;
  }
</style>
